import {AxiosResponse} from 'axios'
import { client } from "../../shared/services/client"; 
import * as constant from '../../shared/util/constant'
import CarrierMappingSnapshot from '../model/CarrierData';
import { CarrierDataViewHeaderModel } from '../model/CarrierDataViewModel';
import CustomerDataSnapshot from '../model/CustomerDataSnapshot';
import LookupService from "../../Services/LookupService";
import { SelectOption } from "../../shared/components/input";
import TransactionSummary from '../model/TransactionSummary';
import CustomerTransactionSummary from '../model/CustomerTransactionSummary';
import { PolicyDtoRead } from '../../customer/model/PolicyDtoRead';
import { PolicyProcessStatus } from '../model/PolicyProcessStatus';
import AtmsCustomers from '../model/AtmsCustomers';
import { CustomerSearch } from '../model/CustomerSearch';
import { buildQueryString } from '../../shared/util/queryStringBuilder';
import { UserStatsResponse } from '../model/UserStatsResponse';
import { formatDate } from '../../shared/util/formatDate';
import { UserStatsData } from "../model/UserStatsData";
import { PolicyDto } from '../../customer/model/PolicyDto';
import { UserStatisticsResponse } from '../model/UserStatisticsResponse';
import { ApplyTransactionDto, ApplyShellTransactionDto } from '../model/ApplyTransactionDto';
import { TransactionResultItem } from '../model/TransactionResultItem';
import TransactionFilter from '../model/TransactionFilter';

class MappingDataAPI {

  getCarrierListByTransactionType = async (transactionTypeCode: string) : Promise<CarrierMappingSnapshot[]> => {
    client.setBaseURLForService("policyMapping")
    const res: AxiosResponse<CarrierMappingSnapshot[]> = await client.get<CarrierMappingSnapshot[]>("/api/PolicyTransaction/GetPolicyTransactionSummryList/" + transactionTypeCode);
    return await res.data;
  }

  //transactionCode?:string, processStatus?:string[],insuredName?:string, carrier?:string, cs2EntryDate?:string, transactionEffectiveDate?:string, effectiveTermDateFrom?:string, effectiveTermDateTo?:string
  getCarrierListwithCount = async (searchFilter : TransactionFilter) : Promise<CarrierDataViewHeaderModel[]> => {
    client.setBaseURLForService("policyMapping")
    const { processStatus, ...filterParams } = searchFilter;
    const filterQueryString = buildQueryString(filterParams);
    const queryString = `${filterQueryString}&${processStatus!.map(status => `processStatus=${encodeURIComponent(status)}`).join("&")}`;
    const res: AxiosResponse<CarrierDataViewHeaderModel[]> = await client.get<CarrierDataViewHeaderModel[]>(`/api/PolicyTransaction/GetCarrierList?${queryString}`);
    return await res.data;
  }

  getCustomerDataByCarrierName = async (carrierName:string) : Promise<CustomerDataSnapshot[]> => {
    client.setBaseURLForService("policyMapping")
    const res: AxiosResponse<CustomerDataSnapshot[]> = await client.get<CustomerDataSnapshot[]>("/api/PolicyTransaction/GetPolicyTransactionSummryListByCarrierName/"+ carrierName);
    return await res.data;
  }
  getCustomerDataByCarrierandTransactionCode = async (searchFilter : TransactionFilter) : Promise<AxiosResponse<CustomerDataSnapshot[]>> => {
    client.setBaseURLForService("policyMapping")
    const { processStatus, ...filterParams } = searchFilter;
     const filterQueryString = buildQueryString(filterParams);
    const queryString = `${filterQueryString}&${processStatus!.map(status => `processStatus=${encodeURIComponent(status)}`).join("&")}`;
    const res: AxiosResponse<CustomerDataSnapshot[]> = await client.get<CustomerDataSnapshot[]>(`/api/PolicyTransaction/FilterPolicyTransactions?${queryString}`);
    return await res;
  }
  getTransactionSummaryByPolicyId= async(policyId:string): Promise<TransactionSummary> => {
    client.setBaseURLForService("policyMapping")
    const res: AxiosResponse<TransactionSummary> = await client.get<TransactionSummary>("/api/PolicyTransaction/GetPolicyTransactionSummary?policyId="+policyId);
    return await res.data;
  }

  getTransactionSummaryList = async (customerFilter: CustomerSearch): Promise<AxiosResponse<CustomerTransactionSummary[]>> => {
    client.setBaseURLForService("policyMapping");
    const queryString = buildQueryString(customerFilter);
    const res: AxiosResponse<CustomerTransactionSummary[]> = await client.get<CustomerTransactionSummary[]>(`/api/PolicyTransaction/FilterCustomers?${queryString}`);
    return await res;
  }
  getPolicySummary= async(customerIds : string[]): Promise<PolicyDtoRead[]> => {
     client.setBaseURLForService("policy")
            const config={}
            const res: AxiosResponse<PolicyDtoRead[]> =  await client.post("/Policy/getpoliciesbycustomerids?policyOption=Summary", customerIds, config);
            return res.data;
  }

    applyPolicyTransaction = async (transactionSummary: TransactionSummary, customerId: string, sourceId: string, sourceType: string, cs2PolicyId: string, cs2PriorPolicyId: string, cs2CustomerNumber: number, parentCompanyId: string, writtingCompanyId: string, policyDto: PolicyDto): Promise<string> => {
      client.setBaseURLForService("policyMapping")
    const applyTransactionDto = {
        policyId: transactionSummary.id,
        custNo: customerId,
        transactionType: transactionSummary.cycleBusinessPurposeCode,
        sourceId: sourceId,
        sourceType: sourceType,
        cs2PolicyId: cs2PolicyId,
        cs2PriorPolicyId: cs2PriorPolicyId,
        transactionTypeCode: transactionSummary.cycleBusinessPurposeCode,
        cs2CustomerNumber: cs2CustomerNumber,
        overridenData: {
          premium: transactionSummary.modifiedPremium,
          effectiveDate: transactionSummary.modifiedEffectiveDate,
          polExpDate: transactionSummary.modifiedExpirationDate,
          mailAddress1: transactionSummary.modifiedMailingAddress1,
          mailAddress2: transactionSummary.modifiedMailingAddress2,
          mailCity: transactionSummary.modifiedMailingCity,
          mailState: transactionSummary.modifiedMailingState,
          mailZipCode: transactionSummary.modifiedMailingZip,
          address1: transactionSummary.modifiedPropertyAddress1,
          address2: transactionSummary.modifiedPropertyAddress2,
          city: transactionSummary.modifiedPropertyCity,
          state: transactionSummary.modifiedPropertyState,
          zipCode: transactionSummary.modifiedPropertyZip
        },
        lob: transactionSummary.lineOfBusinessCode,        
        parentCompanyId: parentCompanyId,
        writtingCompanyId: writtingCompanyId,
        policyDto: { ...policyDto, changedDate: new Date(), enteredDate: new Date() }
      };
    const config = {}
    const res: AxiosResponse<string> = await client.post("/api/PolicyTransaction/ApplyTransaction", applyTransactionDto);
    return res.data;
  }

  applyMultiTransaction = async (transactions: ApplyTransactionDto[]): Promise<TransactionResultItem[]> => {
    client.setBaseURLForService("policyMapping");
    const config = {};
    const res: AxiosResponse<TransactionResultItem[]> = await client.post("/api/PolicyTransaction/ApplyMultiTransaction", transactions, config);
    return res.data;
  }

  applyShellPolicyTransaction = async (dto: ApplyShellTransactionDto): Promise<string> => {
    client.setBaseURLForService("policyMapping");
    const res: AxiosResponse<string> = await client.post("/api/PolicyTransaction/ApplyShellPolicyTransaction", dto);
    return res.data;
  }

  updateProcessStatus = async (policyProcessStatus:PolicyProcessStatus): Promise<string> => {
    client.setBaseURLForService("policyMapping")
    const config = {}
    const res: AxiosResponse<string> = await client.post("/api/PolicyTransaction/UpdatePolicyProcessStatus",policyProcessStatus, config); 
    return res.data;
  }

  createCustomerAndApplyPolicyTransaction = async (policyId: string, agencyId: string, sourceType: string, sourceId: string, transactionType: string , lineOfBusiness : string, parentComapnyId: string, writtingCompanyId: string): Promise<string> => {
    client.setBaseURLForService("policyMapping")
    const config = {}
    const res: AxiosResponse<string> = await client.post("/api/PolicyTransaction/CreateCustomerAndApplyTransaction?policyId=" + policyId + "&sourceId=" + sourceId + "&sourceType=" + sourceType + "&agencyId=" + agencyId + "&transactionType=" + transactionType+"&lob="+lineOfBusiness +"&parentCompany="+parentComapnyId +"&writtingCompany="+writtingCompanyId, config);
    return res.data;
  }

   getSourceList = async (sourceType: string): Promise<any[]> => {
    client.setBaseURLForService("policyMapping")
    const config = {}
    const res: AxiosResponse<string> = await client.get("/api/PolicyTransaction/GetSourceList?sourceType=" +  sourceType);
    return res.data;
  }

  getAtmsCustomerList = async (customerFilter: CustomerSearch): Promise<AxiosResponse<AtmsCustomers[]>> => {
    client.setBaseURLForService("policyMapping");
    const queryString = buildQueryString(customerFilter);
    const res: AxiosResponse<AtmsCustomers[]> = await client.get<AtmsCustomers[]>(`/api/PolicyTransaction/FilterCustomersFromATMS?${queryString}`);
    return await res;
  }

  createCustomerFromAtmsAndApplyPolicyTransaction = async (policyId: string, leadId: string, transactionType: string, lineOfBusiness : string): Promise<string> => {
    client.setBaseURLForService("policyMapping")
    const config = {}
    const res: AxiosResponse<string> = await client.post("/api/PolicyTransaction/CreateCustomerFromATMSAndApplyTransaction?policyId=" + policyId + "&leadId=" + leadId + "&transactionType=" + transactionType + "&lob="+lineOfBusiness, config);
    return res.data;
    }

    getStatistics = async (fromDate: string, toDate: string): Promise<UserStatsResponse[]> => {
        client.setBaseURLForService("policyMapping");
        const res: AxiosResponse<UserStatsResponse[]> = await client.get<UserStatsResponse[]>("/api/PolicyTransaction/GetStatistics", {
            params: {                
                fromDate: formatDate(fromDate),
                toDate: formatDate(toDate)                
            }
        });
        return res.data;
    }

    getUserStatistics = async (fromDate?: Date | string, toDate?: Date | string): Promise<UserStatisticsResponse> => {
        client.setBaseURLForService("policyMapping");
        const res: AxiosResponse<UserStatisticsResponse> = await client.get<UserStatisticsResponse>("/api/PolicyTransaction/GetUserStatistics", {
            params: {
                fromDate: formatDate(fromDate),
                toDate: formatDate(toDate)
            }
        });
        return res.data;
    }
}

export default MappingDataAPI